import { filterArchived } from '../../utils';

export const addEmptyObject = (items: [{ id: string; code: string }]) => {
  items.push({ id: '', code: '' });
  return items.reverse();
};

export const normalizeDataServiceReasonType = (items: [{ id: string; code: string; archived: boolean }]) => {

  return filterArchived(items).map((item: any) => ({
        id: item.id,
        code: item.code,
        value: item.id,
        label: item.label ?? item.code,
    }))
};
